export default __webpack_public_path__ + "static/9_Screenshot-23b52a0e2718b5fd18dd1aed134bca9a.png";